export enum TaskActions {
  LoadTask = 'Load tasks',
  TaskAccepted = 'Tasks accepted',
  UpdateTask = 'Update Task',
}
